/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Module_Add_Operator_User_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Enter a name" |
*
* @param {Module_Add_Operator_User_PlaceholderInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const module_add_operator_user_placeholder = /** @type {((inputs?: Module_Add_Operator_User_PlaceholderInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Module_Add_Operator_User_PlaceholderInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Enter a name")
	return /** @type {LocalizedString} */ ("Saisissez un nom")
});